import axios, { isAxiosError } from 'axios'
import router from '@/router'
import { getUserFriendlyErrorMessage } from '@/utils/error-message'

const instance = axios.create({
  headers: {
    'Content-Type': 'application/json',
    lang: 'ar_001'
  }
})

function cookieValue(name: string) {
  if (typeof document === 'undefined') return undefined

  return document.cookie
    .split('; ')
    .find((entry) => entry.startsWith(`${name}=`))
    ?.slice(name.length + 1)
}

// Legacy Odoo-compatible login establishes the same Go session used by the
// native API. Attach its double-submit CSRF token only to state-changing native
// requests, leaving all existing compatibility traffic untouched.
instance.interceptors.request.use((config) => {
  const method = config.method?.toLowerCase()
  const isNativeWrite =
    config.url?.includes('/api/v1/') && !['get', 'head', 'options'].includes(method ?? 'get')
  const csrfToken = isNativeWrite ? cookieValue('maqari_session_csrf') : undefined

  if (csrfToken) {
    config.headers.set('X-CSRF-Token', decodeURIComponent(csrfToken))
  }

  return config
})

instance.interceptors.response.use(
  (response) => {
    if (response.data?.error?.message) {
      response.data.error.message = getUserFriendlyErrorMessage(response.data.error)
    }

    if (response?.data?.error?.code == 100) {
      localStorage.clear()

      // if (router.currentRoute.value.name != 'login') {

      //   router.push({ name: 'login' })
      // }
      // window.location.href = '/login'
    }

    return response
  },
  async (error) => {
    if (isAxiosError(error)) {
      error.message = getUserFriendlyErrorMessage(error)

      const requestURL = error.config?.url ?? ''
      if (
        !import.meta.env.SSR &&
        error.response?.status &&
        error.response.status >= 500 &&
        !requestURL.includes('/observability')
      ) {
        window.dispatchEvent(new CustomEvent('observability:request-error', { detail: error }))
      }
    }

    if (isAxiosError(error) && error.response?.data?.error?.code == 100) {
      localStorage.clear()
      // router.push({ name: 'home' })

      if (router.currentRoute.value.name !== 'login') {
        window.location.href = '/login'
      }
    }

    return Promise.reject(error)
  }
)

export default instance

/*

{
	"error": {
		"code": 100,
		"message": "Odoo Session Expired",
		"data": {
			"name": "odoo.http.SessionExpiredException",
			"debug": "Traceback (most recent call last):\n  File \"/usr/lib/python3/dist-packages/odoo/http.py\", line 624, in _handle_exception\n    return super(JsonRequest, self)._handle_exception(exception)\n  File \"/usr/lib/python3/dist-packages/odoo/http.py\", line 310, in _handle_exception\n    raise pycompat.reraise(type(exception), exception, sys.exc_info()[2])\n  File \"/usr/lib/python3/dist-packages/odoo/tools/pycompat.py\", line 14, in reraise\n    raise value\n  File \"/usr/lib/python3/dist-packages/odoo/addons/http_routing/models/ir_http.py\", line 460, in _dispatch\n    cls._authenticate(func.routing['auth'])\n  File \"/usr/lib/python3/dist-packages/odoo/addons/base/models/ir_http.py\", line 124, in _authenticate\n    getattr(cls, \"_auth_method_%s\" % auth_method)()\n  File \"/usr/lib/python3/dist-packages/odoo/addons/base/models/ir_http.py\", line 97, in _auth_method_user\n    raise http.SessionExpiredException(\"Session expired\")\nodoo.http.SessionExpiredException: Session expired\n",
			"message": "Session expired",
			"arguments": [
				"Session expired"
			],
			"exception_type": "internal_error",
			"context": {}
		}
	}
}
  
*/
